import { providers } from 'ethers';
import {
	type PublicClient,
	getPublicClient,
	type WalletClient,
	getWalletClient
} from '@wagmi/core';
import { optimism } from '@wagmi/core/chains';

export function walletClientToSigner(walletClient: WalletClient) {
	const { account, chain, transport } = walletClient;
	const network = {
		chainId: chain.id,
		name: chain.name,
		ensAddress: chain.contracts?.ensRegistry?.address
	};
	const provider = new providers.Web3Provider(transport as any, network);
	const signer = provider.getSigner(account.address);
	return signer;
}

/** Action to convert a viem Wallet Client to an ethers.js Signer. */
export async function getEthersSigner({ chainId }: { chainId?: number } = {}) {
	chainId = optimism.id;
	const walletClient = await getWalletClient({ chainId });
	if (!walletClient) return undefined;
	return walletClientToSigner(walletClient);
}

export function publicClientToProvider(publicClient: PublicClient) {
	const { chain, transport } = publicClient;
	const network = {
		chainId: chain.id,
		name: chain.name,
		ensAddress: chain.contracts?.ensRegistry?.address
	};
	if (transport.type === 'fallback')
		return new providers.FallbackProvider(
			transport.transports.map(({ value }) => new providers.JsonRpcProvider(value?.url, network))
		);
	return new providers.JsonRpcProvider(transport.url, network);
}

export function getEthersProvider({ chainId }: { chainId?: number } = {}) {
	chainId = optimism.id;
	const publicClient = getPublicClient({ chainId });
	return publicClientToProvider(publicClient);
}
